import { NgxPermissionsService } from "ngx-permissions";
import { DataConsts } from "./../../models/DataConsts";
import { ViewItemModalComponent } from "./view-item-modal/view-item-modal.component";
import { NgbdModalConfirm } from "../../services/modal-confirm";
import { DatePipe } from "@angular/common";
import { AddItemModalComponent } from "./add-item-modal/add-item-modal.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ImportPortefeuille } from "../../models/ImportPortefeuille";
import { FondsPropresService } from "../../services/fonds-propres.service";
import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTable, MatTableDataSource } from "@angular/material/table";

@Component({
  selector: "app-importations",
  templateUrl: "./importations.component.html",
  styleUrls: ["./importations.component.scss"],
})
export class ImportationsComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator, { static: false })
  paginator: MatPaginator;
  @ViewChild(MatSort, { static: false })
  sort: MatSort;
  dataSource: MatTableDataSource<ImportPortefeuille>;
  isLoadingResults = false;
  IMPORT_STATUS: string = DataConsts.ENATTENTE;
  IMPORT_VALIDE_STATUS: string = DataConsts.VALIDER;
  IMPORT_CHARGEMENT_STATUS: string = DataConsts.CHARGEMENT;

  /** Columns displayed in the table. Columns IDs can be added, removed, or reordered. */
  displayedColumns = [
    "id",
    "libelle",
    "description",
    "nombreTotal",
    "nombreEcarts",
    "status",
    "createdDate",
    "createdBy",
    "actions",
  ];
  data: ImportPortefeuille[] = [];

  constructor(
    private shared: FondsPropresService,
    private modalService: NgbModal,
    private permissionsService: NgxPermissionsService
  ) {}

  ngOnInit() {
    this.getImportPortefeuilles();
    var permissions = this.permissionsService.getPermissions();
    console.log(permissions);
  }

  getImportPortefeuilles() {
    this.isLoadingResults = true;
    this.shared.getImportPortefeuilles().subscribe(
      (data) => {
        this.data = data;
      },
      (error) => {
        console.log(error);
        this.isLoadingResults = false;
      },
      () => {
        if (this.data == null) {
          this.data = [];
        }
        console.log("========DDDDDDDD=======", this.data);

        this.dataSource = new MatTableDataSource(this.data);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.isLoadingResults = false;
      }
    );
  }

  ngAfterViewInit() {
    //this.dataSource.sort = this.sort;
    //this.dataSource.paginator = this.paginator;
  }

  addItemModal() {
    const modalRef = this.modalService.open(AddItemModalComponent, {
      centered: true,
      backdropClass: "light-blue-backdrop",
      backdrop: "static",
      windowClass: "my-app-app-modal-class",
    });
    //modalRef.componentInstance.profile = this.profile;

    modalRef.result.then(
      (result) => {
        console.log("result", result);
        // on close
        this.getImportPortefeuilles();
      },
      (reason) => {
        console.log("reason", reason);
        // on dismiss
      }
    );
  }

  //row in modal popup
  manageImportPortefeuille(row, activite) {
    const modalRef = this.modalService.open(AddItemModalComponent, {
      centered: true,
      backdropClass: "light-blue-backdrop",
      backdrop: "static",
      //scrollable: true,
      windowClass: "my-app-app-modal-class",
    });
    modalRef.componentInstance.importPortefeuille = row;
    modalRef.componentInstance.title = "Mise à jour de l'importation";
    if (activite == "add") {
      modalRef.componentInstance.title = "Importation de portefeuille";
    }

    modalRef.result.then(
      (result) => {
        console.log("result", result);
        // on close
        this.getImportPortefeuilles();
      },
      (reason) => {
        console.log("reason", reason);
        // on dismiss
      }
    );
  }

  viewItemModal(row) {
    const viewModalRef = this.modalService.open(ViewItemModalComponent, {
      centered: true,
      backdropClass: "light-blue-backdrop",
      backdrop: "static",
      scrollable: true,
      windowClass: "my-modal-class",
    });
    viewModalRef.componentInstance.portefeuille = row;

    viewModalRef.result.then(
      (result) => {
        console.log("result", result);
        // on close
      },
      (reason) => {
        console.log("reason", reason);
        // on dismiss
      }
    );
  }

  refresh() {
    this.getImportPortefeuilles();
  }

  //delete specific import
  deleteImportPortefeuille($event: MouseEvent, row) {
    ($event.currentTarget as HTMLButtonElement).disabled = true;
    //message en popup
    const modalConfirmRef = this.modalService.open(NgbdModalConfirm, {
      centered: true,
    });
    modalConfirmRef.componentInstance.title = "Suppression #" + row.id;
    modalConfirmRef.componentInstance.libelle = row.libelle;
    modalConfirmRef.componentInstance.queryMessage =
      "Etes-vous sûr de vouloir supprimer le dossier";
    modalConfirmRef.componentInstance.description =
      '<p>Toutes les informations associées à ce dossier seront définitivement supprimées. <span class="text-danger"> Cette opération sera définitive.</span>';
    modalConfirmRef.componentInstance.btnMessage = "Oui, supprimer";

    modalConfirmRef.result.then(
      (result) => {
        console.log("modalConfirmRefResult", result);
        // on close
        this.isLoadingResults = true;
        this.shared.deleteImportPortefeuille(row.id).subscribe(
          (data) => {
            console.log(data);
            this.getImportPortefeuilles();
          },
          (error) => {
            this.isLoadingResults = false;
          },
          () => {
            this.isLoadingResults = false;
          }
        );
      },
      (reason) => {
        console.log("reason", reason);
        //on dismiss
      }
    );
  }

  //Validate specific import
  validatePortefeuilleById($event: MouseEvent, row) {
    ($event.currentTarget as HTMLButtonElement).disabled = true;

    //message en popup
    const modalConfirmRef = this.modalService.open(NgbdModalConfirm, {
      centered: true,
    });
    modalConfirmRef.componentInstance.title = "Validation #" + row.id;
    modalConfirmRef.componentInstance.libelle = row.libelle;
    modalConfirmRef.componentInstance.queryMessage =
      "Etes-vous sûr de vouloir valider le dossier";
    modalConfirmRef.componentInstance.description =
      "<p> Toutes les informations associées à ce dossier seront définitivement validées. </p>";
    modalConfirmRef.componentInstance.btnMessage = "Oui, valider";

    modalConfirmRef.result.then(
      (result) => {
        console.log("modalConfirmRefResult", result);
        // on close
        this.isLoadingResults = true;
        this.shared.validatePortefeuilleById(row.id).subscribe(
          (data) => {
            console.log(data);
            //this.getImportPortefeuilles();
          },
          (error) => {
            this.isLoadingResults = false;
          },
          () => {
            this.isLoadingResults = false;
          }
        );
      },
      (reason) => {
        console.log("reason", reason);
        //on dismiss
      }
    );
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
